/* Warmith product page behaviour (Horizon).
   Gallery + zoom, colour/bundle selection, fit pop-up, accordions, FAQ, sticky add-to-cart bar,
   reviews "show all". Adding to the cart is done by Horizon's own <product-form-component>, so the
   cart drawer, cart count and cart events behave exactly like the rest of the theme. */

function formatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const placeholder = /\{\{\s*(\w+)\s*\}\}/;
  const fmt = format || '${{amount}}';
  const withDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
    if (isNaN(number) || number == null) return '0';
    const fixed = (number / 100).toFixed(precision).split('.');
    const whole = fixed[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (fixed[1] ? decimal + fixed[1] : '');
  };
  const key = (fmt.match(placeholder) || [])[1] || 'amount';
  const table = {
    amount: () => withDelimiters(cents, 2),
    amount_no_decimals: () => withDelimiters(cents, 0),
    amount_with_comma_separator: () => withDelimiters(cents, 2, '.', ','),
    amount_no_decimals_with_comma_separator: () => withDelimiters(cents, 0, '.', ','),
    amount_with_space_separator: () => withDelimiters(cents, 2, ' ', ','),
    amount_no_decimals_with_space_separator: () => withDelimiters(cents, 0, ' ', ','),
    amount_with_apostrophe_separator: () => withDelimiters(cents, 2, "'", '.'),
  };
  const value = (table[key] || table.amount)();
  return fmt.replace(placeholder, value).replace(/<[^>]*>/g, '').trim();
}

const $ = (root, sel) => root.querySelector(sel);
const $$ = (root, sel) => Array.from(root.querySelectorAll(sel));
const readJSON = (el) => {
  if (!el) return null;
  try { return JSON.parse(el.textContent); } catch (e) { return null; }
};

/* ---------------- accordions (buy box + FAQ): one open at a time ---------------- */
function initAccordion(list) {
  if (!list || list.dataset.hcReady) return;
  list.dataset.hcReady = '1';
  const buttons = $$(list, '[data-hc-acc]');
  const set = (btn, open) => {
    btn.classList.toggle('hc-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (panel) panel.hidden = !open;
  };
  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const willOpen = btn.getAttribute('aria-expanded') !== 'true';
      buttons.forEach((b) => set(b, false));
      if (willOpen) set(btn, true);
    });
  });
}

const unlockScroll = () => document.documentElement.classList.remove('hc-noscroll');

/* ---------------- gallery + zoom ---------------- */
function initGallery(root) {
  const stage = $(root, '[data-hc-stage]');
  if (!stage) return { goToMedia() {} };
  const slides = $$(stage, '[data-hc-slide]');
  const thumbs = $$(root, '[data-hc-thumb]');
  const counters = $$(root, '[data-hc-idx]');
  const zoom = $(root, '[data-hc-zoom]');
  const zoomImg = zoom ? $(zoom, '[data-hc-zoom-img]') : null;
  const zoomView = zoom ? $(zoom, '[data-hc-zoom-view]') : null;
  const zoomBig = zoom ? $(zoom, '[data-hc-zoom-big]') : null;
  const total = slides.length;
  let current = 0;

  const fillZoom = () => {
    if (!zoomImg || !slides[current]) return;
    const full = slides[current].dataset.full;
    const img = $(slides[current], 'img');
    zoomImg.src = full || (img ? img.currentSrc || img.src : '');
    zoomImg.alt = img ? img.alt : '';
  };
  const setBig = (big) => {
    if (!zoomView) return;
    zoomView.classList.toggle('hc-big', big);
    zoomView.classList.toggle('hc-fit', !big);
    if (zoomBig) {
      zoomBig.classList.toggle('hc-on', big);
      zoomBig.setAttribute('aria-pressed', big ? 'true' : 'false');
    }
    if (big) {
      requestAnimationFrame(() => {
        zoomView.scrollLeft = (zoomView.scrollWidth - zoomView.clientWidth) / 2;
        zoomView.scrollTop = (zoomView.scrollHeight - zoomView.clientHeight) / 2;
      });
    }
  };
  const go = (i) => {
    if (!total) return;
    current = ((i % total) + total) % total;
    slides.forEach((s, k) => {
      s.classList.toggle('hc-on', k === current);
      s.setAttribute('aria-hidden', k === current ? 'false' : 'true');
      if (k === current) {
        const img = $(s, 'img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
      }
    });
    thumbs.forEach((t, k) => {
      t.classList.toggle('hc-on', k === current);
      t.setAttribute('aria-pressed', k === current ? 'true' : 'false');
    });
    const li = thumbs[current] && thumbs[current].parentElement;
    const list = li && li.parentElement;
    if (list) {
      const left = li.offsetLeft - list.offsetLeft;
      if (left < list.scrollLeft || left + li.offsetWidth > list.scrollLeft + list.clientWidth) {
        list.scrollTo({ left: Math.max(0, left - 4), behavior: 'smooth' });
      }
    }
    counters.forEach((c) => { c.textContent = String(current + 1); });
    if (zoom && zoom.open) fillZoom();
  };
  const openZoom = () => {
    if (!zoom || typeof zoom.showModal !== 'function') return;
    fillZoom();
    setBig(false);
    if (!zoom.open) zoom.showModal();
    document.documentElement.classList.add('hc-noscroll');
  };
  const closeZoom = () => { if (zoom && zoom.open) zoom.close(); unlockScroll(); };

  $$(root, '[data-hc-prev]').forEach((b) => b.addEventListener('click', () => go(current - 1)));
  $$(root, '[data-hc-next]').forEach((b) => b.addEventListener('click', () => go(current + 1)));
  thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
  $$(root, '[data-hc-zoom-open]').forEach((b) => b.addEventListener('click', openZoom));

  stage.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
    else if ((e.key === 'Enter' || e.key === ' ') && e.target === stage) { e.preventDefault(); openZoom(); }
  });
  let tx = null;
  stage.addEventListener('touchstart', (e) => { tx = e.touches && e.touches[0] ? e.touches[0].clientX : null; }, { passive: true });
  stage.addEventListener('touchend', (e) => {
    const t = e.changedTouches && e.changedTouches[0];
    if (!t || tx === null) return;
    const d = t.clientX - tx;
    if (d > 40) go(current - 1); else if (d < -40) go(current + 1);
    tx = null;
  });

  if (zoom) {
    $$(zoom, '[data-hc-zoom-close]').forEach((b) => b.addEventListener('click', closeZoom));
    if (zoomBig) zoomBig.addEventListener('click', () => setBig(!zoomView.classList.contains('hc-big')));
    if (zoomImg) zoomImg.addEventListener('click', () => setBig(!zoomView.classList.contains('hc-big')));
    zoom.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
    });
    zoom.addEventListener('cancel', unlockScroll);
    zoom.addEventListener('close', () => { unlockScroll(); setBig(false); });
  }

  go(0);
  return {
    goToMedia(id) {
      if (!id) return;
      const k = slides.findIndex((s) => s.dataset.mediaId === String(id));
      if (k >= 0) go(k);
    },
  };
}

/* ---------------- fit pop-up ---------------- */
function initFit(root) {
  const dlg = $(root, '[data-hc-fit]');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  const open = () => { if (!dlg.open) dlg.showModal(); document.documentElement.classList.add('hc-noscroll'); };
  const close = () => { if (dlg.open) dlg.close(); unlockScroll(); };
  $$(root, '[data-hc-fit-open]').forEach((b) => b.addEventListener('click', open));
  $$(dlg, '[data-hc-fit-close]').forEach((b) => b.addEventListener('click', close));
  const shade = $(dlg, '[data-hc-fit-shade]');
  if (shade) shade.addEventListener('click', (e) => { if (e.target === shade) close(); });
  dlg.addEventListener('cancel', unlockScroll);
  dlg.addEventListener('close', unlockScroll);
}

/* ---------------- variants, add to cart, sticky bar ---------------- */
function initBuy(root, gallery) {
  const variants = readJSON($(root, '[data-hc-variants]')) || [];
  const cfg = readJSON($(root, '[data-hc-config]')) || {};
  const idInput = $(root, '[data-hc-variant-id]');
  const addBtn = $(root, '[data-hc-add]');
  const addLabel = $(root, '[data-hc-add-label]');
  const status = $(root, '[data-hc-status]');
  const groups = $$(root, '[data-hc-opt-index]');
  const atc = $(root, 'add-to-cart-component');
  const bar = $(root, '[data-hc-sab]');
  const barSelect = bar ? $(bar, '[data-hc-sab-select]') : null;
  const barBtn = bar ? $(bar, '[data-hc-sab-add]') : null;
  const barSm = bar ? $(bar, '[data-hc-sab-sm]') : null;
  const barLg = bar ? $(bar, '[data-hc-sab-lg]') : null;
  const barPrice = bar ? $(bar, '[data-hc-sab-price]') : null;
  const barCompare = bar ? $(bar, '[data-hc-sab-compare]') : null;
  const barVariant = bar ? $(bar, '[data-hc-sab-variant]') : null;
  const barStatus = bar ? $(bar, '[data-hc-sab-status]') : null;
  const bundleIndex = parseInt(root.dataset.bundleIndex, 10);
  const money = (c) => formatMoney(c, cfg.moneyFormat);
  const addText = cfg.addLabel || 'Add to cart';
  const soldText = cfg.soldOut || 'Sold out';
  if (!idInput || !variants.length) return;

  const selected = () => {
    const out = [];
    groups.forEach((g) => {
      const idx = parseInt(g.dataset.hcOptIndex, 10);
      const checked = $(g, 'input[type="radio"]:checked');
      out[idx] = checked ? checked.value : null;
    });
    return out;
  };
  const find = (opts) => variants.find((v) => opts.every((o, j) => o == null || v.options[j] === o)) || null;
  let currentVariant = null;

  const apply = (pushUrl) => {
    const opts = selected();
    const v = find(opts);
    currentVariant = v;

    groups.forEach((g) => {
      const checked = $(g, 'input[type="radio"]:checked');
      $$(g, 'label').forEach((l) => l.classList.toggle('hc-on', !!checked && l.htmlFor === checked.id));
      const valueEl = $(g, '[data-hc-opt-value]');
      if (valueEl && checked) valueEl.textContent = checked.value;
    });

    if (!isNaN(bundleIndex) && bundleIndex >= 0) {
      $$(root, '[data-hc-tier]').forEach((tier) => {
        const o = opts.slice();
        o[bundleIndex] = tier.dataset.value;
        const tv = find(o);
        const p = $(tier, '[data-hc-tier-price]');
        const c = $(tier, '[data-hc-tier-compare]');
        if (!tv) { if (p) p.textContent = cfg.unavailable || 'Unavailable'; if (c) c.hidden = true; tier.dataset.soldout = 'true'; return; }
        if (p) p.textContent = money(tv.price);
        if (c) {
          const show = cfg.showCompare && tv.compare_at_price && tv.compare_at_price > tv.price;
          c.hidden = !show;
          if (show) c.textContent = money(tv.compare_at_price);
        }
        if (tv.available) delete tier.dataset.soldout; else tier.dataset.soldout = 'true';
      });
    }

    if (!v) {
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = cfg.unavailable || 'Unavailable';
      if (barBtn) barBtn.disabled = true;
      return;
    }
    idInput.value = String(v.id);
    const available = !!v.available;
    const price = money(v.price);
    const hasCompare = cfg.showCompare && v.compare_at_price && v.compare_at_price > v.price;
    if (addBtn) addBtn.disabled = !available;
    if (addLabel) addLabel.textContent = available ? `${addText} · ${price}` : soldText;
    if (barBtn) barBtn.disabled = !available;
    if (barSm) barSm.textContent = available ? `${addText} · ${price}` : soldText;
    if (barLg) barLg.textContent = available ? addText : soldText;
    if (barPrice) barPrice.textContent = price;
    if (barCompare) { barCompare.hidden = !hasCompare; if (hasCompare) barCompare.textContent = money(v.compare_at_price); }
    if (barVariant) {
      const others = v.options.filter((o, j) => j !== bundleIndex);
      barVariant.textContent = [others.join(' / '), cfg.sizeNote].filter(Boolean).join(' · ');
    }
    if (barSelect && !isNaN(bundleIndex) && bundleIndex >= 0) barSelect.value = v.options[bundleIndex];
    if (atc && v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) {
      atc.setAttribute('data-product-variant-media', v.featured_media.preview_image.src + '&width=100');
    }
    if (gallery && v.featured_media && v.featured_media.id && pushUrl) gallery.goToMedia(v.featured_media.id);
    if (status) status.textContent = '';
    if (pushUrl && window.history && window.history.replaceState) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(v.id));
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) { /* ignore */ }
    }
  };

  groups.forEach((g) => g.addEventListener('change', (e) => {
    if (e.target && e.target.matches('input[type="radio"]')) apply(true);
  }));

  // Horizon sets data-added="true" on the button after a successful add, then removes it.
  if (addBtn && 'MutationObserver' in window) {
    new MutationObserver(() => {
      const added = addBtn.dataset.added === 'true';
      if (added && currentVariant) {
        const bundle = !isNaN(bundleIndex) && bundleIndex >= 0 ? currentVariant.options[bundleIndex] : currentVariant.title;
        const others = currentVariant.options.filter((o, j) => j !== bundleIndex).join(' / ');
        const msg = `Added ${bundle}${others ? ` (${others})` : ''} to your cart.`;
        if (status) status.textContent = msg;
        if (barStatus) barStatus.textContent = msg;
      }
      if (bar) bar.classList.toggle('hc-added', added);
      if (barSm && added) barSm.textContent = cfg.addedLabel || 'Added to cart';
      if (barLg && added) barLg.textContent = cfg.addedLabel || 'Added to cart';
      if (!added) apply(false);
    }).observe(addBtn, { attributes: true, attributeFilter: ['data-added'] });
  }

  if (barSelect) {
    barSelect.addEventListener('change', () => {
      const g = groups.find((x) => parseInt(x.dataset.hcOptIndex, 10) === bundleIndex);
      if (!g) return;
      const input = $$(g, 'input[type="radio"]').find((i) => i.value === barSelect.value);
      if (input) { input.checked = true; apply(true); }
    });
  }
  if (barBtn && addBtn) {
    barBtn.addEventListener('click', () => { if (!addBtn.disabled) addBtn.click(); });
  }

  // show the bar once the main button has scrolled up out of view
  if (bar && addBtn) {
    let raf = 0;
    const check = () => {
      raf = 0;
      const r = addBtn.getBoundingClientRect();
      const header = document.querySelector('header-component');
      const top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const show = r.height > 0 && r.bottom < top;
      bar.classList.toggle('hc-on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.inert = !show;
      // keep the bar clear of the page scrollbar when .page-wrapper is the scroller
      const pw = document.querySelector('.page-wrapper');
      const gap = pw && pw.scrollHeight > pw.clientHeight && getComputedStyle(pw).overflowY !== 'visible' ? pw.offsetWidth - pw.clientWidth : 0;
      bar.style.right = gap > 0 ? gap + 'px' : '';
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(check); };
    // capture catches scrolls on Horizon's .page-wrapper (desktop) as well as the document (mobile)
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
    check();
  }

  apply(false);
}

/* ---------------- reviews: show all ---------------- */
function initReviews(root) {
  const btn = $(root, '[data-hc-rev-toggle]');
  const grid = $(root, '[data-hc-rev-grid]');
  if (!btn || !grid || btn.dataset.hcReady) return;
  btn.dataset.hcReady = '1';
  btn.addEventListener('click', () => {
    const all = !grid.classList.contains('hc-all');
    grid.classList.toggle('hc-all', all);
    btn.setAttribute('aria-expanded', all ? 'true' : 'false');
    btn.textContent = all ? btn.dataset.less : btn.dataset.more;
  });
}

/* ---------------- photo slider: load every card before it scrolls into view ---------------- */
function initUgc(track) {
  if (track.dataset.hcReady) return;
  track.dataset.hcReady = '1';
  const load = () => $$(track, 'img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
  if (!('IntersectionObserver' in window)) { load(); return; }
  const pw = document.querySelector('.page-wrapper');
  const desktop = window.matchMedia('(min-width: 990px)').matches;
  const io = new IntersectionObserver((entries) => {
    if (entries.some((e) => e.isIntersecting)) { load(); io.disconnect(); }
  }, { root: desktop && pw ? pw : null, rootMargin: '800px 0px' });
  io.observe(track);
}

function initMain(root) {
  if (root.dataset.hcReady) return;
  root.dataset.hcReady = '1';
  const gallery = initGallery(root);
  initBuy(root, gallery);
  initFit(root);
}

function initAll(scope = document) {
  $$(scope, '[data-hc-main]').forEach(initMain);
  $$(scope, '[data-hc-acc-list]').forEach(initAccordion);
  $$(scope, '[data-hc-reviews]').forEach(initReviews);
  $$(scope, '.hc-ugc__track').forEach(initUgc);
  if (scope !== document && scope.matches) {
    if (scope.matches('[data-hc-main]')) initMain(scope);
  }
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
else initAll();
document.addEventListener('shopify:section:load', (e) => initAll(e.target || document));